import { Config } from "src/app/config";
import { PageObject, PAGEOBJECTTYPE } from "./pageobject";
import { ObjectProperty, OBJECTPROPERTYTYPE } from "./objectproperty";

export class PageObjectLink extends PageObject {
  text: string;
  url: string;
  style: string;
  color: string;
  font: string;
  fontSize: number;
  lineHeight: number;
  align: string;

  constructor(obj: PageObjectLink = null, style: string = "") {
    super(obj);
    this._type = PAGEOBJECTTYPE.Link;

    if (obj == null) {
      this.text = "New Text";
      this.url = "";
      this.style = "text-normal";
      this.color = "#000";
      this.font = "arial";
      this.fontSize = 16;
      this.lineHeight = 24;
      this.align = "left";

      if (Config.STYLE[style]) {
        if (Config.STYLE[style][this.style]) {
          this.color = Config.STYLE[style][this.style].color;
          this.font = Config.STYLE[style][this.style].font;
          this.fontSize = Config.STYLE[style][this.style].fontSize;
          this.lineHeight = Config.STYLE[style][this.style].lineHeight;
          this.align = Config.STYLE[style][this.style].align;
        }
      }
    } else {
      this.text = obj.text;
      this.url = obj.url;
      this.style = obj.style || "";
      this.color = obj.color;
      this.font = obj.font;
      this.fontSize = obj.fontSize;
      this.lineHeight = obj.lineHeight;
      this.align = obj.align;
      if (this.style != "") {
        if (Config.STYLE[style]) {
          if (Config.STYLE[style][this.style]) {
            this.color = Config.STYLE[style][this.style].color;
            this.font = Config.STYLE[style][this.style].font;
            this.fontSize = Config.STYLE[style][this.style].fontSize;
            this.lineHeight = Config.STYLE[style][this.style].lineHeight;
            this.align = Config.STYLE[style][this.style].align;
          }
        }
      }
    }
  }

  getPropertiesList(): ObjectProperty[] {
    let list = super.getPropertiesList();

    list.push(new ObjectProperty("Text", OBJECTPROPERTYTYPE.TextLong));
    list.push(new ObjectProperty("URL", OBJECTPROPERTYTYPE.Text));
    let style = new ObjectProperty("Style", OBJECTPROPERTYTYPE.List);
    style.addOption("text-title", "Title");
    style.addOption("text-subtitle", "Sub Title");
    style.addOption("text-normal", "Normal");
    style.addOption("text-normal-sm", "Normal Small");
    style.addOption("text-normal-lg", "Normal Large");
    style.addOption("text-normal-center", "Normal Center");
    style.addOption("text-normal-sm-center", "Normal Small Center");
    style.addOption("text-normal-lg-center", "Normal Large Center");
    style.addOption("designer-note", "Designer Note");
    style.addOption("", "Custom");
    list.push(style);

    if (this.style == "") {
      list.push(new ObjectProperty("Color", OBJECTPROPERTYTYPE.Text));
      list.push(new ObjectProperty("Font", OBJECTPROPERTYTYPE.Text));
      list.push(new ObjectProperty("Font Size", OBJECTPROPERTYTYPE.Text));
      list.push(new ObjectProperty("Line Height", OBJECTPROPERTYTYPE.Text));
      let align = new ObjectProperty("Align", OBJECTPROPERTYTYPE.List);
      align.addOption("left", "Left");
      align.addOption("center", "Center");
      align.addOption("right", "Right");
      align.addOption("justify", "Justify");
      list.push(align);
    }

    return list;
  }

  getPropertyValue(name: string): any {
    if (name == "Text") {
      return this.text;
    } else if (name == "URL") {
      return this.url;
    } else if (name == "Style") {
      return this.style;
    } else if (name == "Color") {
      return this.color;
    } else if (name == "Font") {
      return this.font;
    } else if (name == "Font Size") {
      return this.fontSize;
    } else if (name == "Line Height") {
      return this.lineHeight;
    } else if (name == "Align") {
      return this.align;
    }

    return super.getPropertyValue(name);
  }

  setPropertyValue(name: string, value: any, style: string): void {
    super.setPropertyValue(name, value, style);

    if (name == "Text") {
      this.text = value;
    } else if (name == "URL") {
      this.url = value;
    } else if (name == "Style") {
      this.style = value;
      if (Config.STYLE[style]) {
        if (Config.STYLE[style][this.style]) {
          this.color = Config.STYLE[style][this.style].color;
          this.font = Config.STYLE[style][this.style].font;
          this.fontSize = Config.STYLE[style][this.style].fontSize;
          this.lineHeight = Config.STYLE[style][this.style].lineHeight;
          this.align = Config.STYLE[style][this.style].align;
        }
      }
    } else if (name == "Color") {
      this.color = value;
    } else if (name == "Font") {
      this.font = value;
    } else if (name == "Font Size") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        this.fontSize = newValue;
      }
    } else if (name == "Line Height") {
      let newValue = Number(value);
      if (!isNaN(newValue)) {
        this.lineHeight = newValue;
      }
    } else if (name == "Align") {
      this.align = value;
    }
  }
}
